import { render, staticRenderFns } from "./waybillInfo.vue?vue&type=template&id=77dac25c&scoped=true"
import script from "./waybillInfo.vue?vue&type=script&lang=js"
export * from "./waybillInfo.vue?vue&type=script&lang=js"
import style0 from "./waybillInfo.vue?vue&type=style&index=0&id=77dac25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dac25c",
  null
  
)

export default component.exports